module.exports = __webpack_public_path__ + "media/images/doc-action-30e0859c243ed4c62a7b3a7db3efdac3.svg";